module.exports = {
  "wxc-stepper": {
    "flexDirection": "row"
  },
  "stepper-plus": {
    "width": 56,
    "height": 56,
    "backgroundColor": "#ededed",
    "alignItems": "center",
    "justifyContent": "center",
    "borderRadius": 6
  },
  "stepper-minus": {
    "width": 56,
    "height": 56,
    "backgroundColor": "#ededed",
    "alignItems": "center",
    "justifyContent": "center",
    "borderRadius": 6
  },
  "stepper-input": {
    "borderWidth": 0,
    "outline": "none",
    "textAlign": "center",
    "color": "#3d3d3d",
    "fontSize": 30,
    "lineHeight": 56,
    "width": 86
  },
  "stepper-icon": {
    "fontSize": 36,
    "color": "#666666",
    "marginTop": -4
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-734551d6!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-stepper/index.vue
// module id = 147
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28